// extracted by mini-css-extract-plugin
module.exports = {"btnContainer":"index_btnContainer__OISpQ","error":"index_error__HtOw9","errorIcon":"index_errorIcon__0C4GJ","errorShow":"index_errorShow__zWw0X","button":"index_button__BPR_U"};